export const VIEWED_MINES = "viewedMines";
